<div class="score-container" *ngIf="score?.value?.color">
  <span class="score {{score.value.color}}">{{('Debtor.CreditScore.' + score.value.color) |
    translate}}</span>

  <span class="description">{{('Debtor.CreditScore.Description.' + score.value.color) | translate}}</span>
</div>
